import cloneDeep from 'lodash/cloneDeep';
import { createReducer } from 'redux-act';
import has from 'lodash/has';
import { setTreatments, setIsVip, registerSplits } from './splitActions';

const initialState = {
  treatments: {},
  isVip: false,
};

export const reducer = createReducer(
  {
    [setTreatments]: (state, treatments) => ({ ...state, treatments }),
    [setIsVip]: (state, isVip) => ({ ...state, isVip }),
    [registerSplits]: (state, splitKeys) => {
      const treatments = cloneDeep(state.treatments);

      // add the new split keys with null values to the store
      splitKeys.forEach((key) => {
        if (!has(treatments, key)) treatments[key] = null;
      });

      return { ...state, treatments };
    },
  },
  initialState,
);
